import React, { Component } from 'react'
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';

import amber from '@material-ui/core/colors/amber';

import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  button: {
    backgroundColor: amber[500],
    color: "#fff",
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
  },
});

class SectionMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchor: null,
    }
  }

  handleClick = event => {
    this.setState({ anchor: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchor: null });
  };

  render() {
    const { menuItems, tooltipType, classes, help } = this.props;
    const { anchor } = this.state;

    return(
      <div>
        {tooltipType &&
          <Tooltip type={tooltipType} placement="left">
            <Button
              className={classNames(classes.button, help.isCurrentStep(tooltipType) && classes.elevate)}
              variant="fab"
              aria-label="add"
              aria-owns={anchor ? 'simple-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick}
            >
              <AddIcon />
            </Button>
          </Tooltip>
        }
        {!tooltipType &&
          <Button
            style={{
              backgroundColor: amber[500],
              color: "#fff",
            }}
            variant="fab"
            aria-label="add"
            aria-owns={anchor ? 'simple-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <AddIcon />
          </Button>
        }
        <Menu
          id="simple-menu"
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={this.handleClose}
        >
        {menuItems.map((menuItem, i) => {
          if (menuItem.type === "divider") {
            return <Divider key={i}/>;
          } else {
            return (
              <MenuItem
                key={i}
                onClick={() => {
                  helpDispatch(tooltipType);
                  const editorStateFn = menuItem.editorState;
                  menuItem.action({...menuItem.payload});
                  editorStateFn && editorStateFn();
                  this.handleClose();
                }}
              >
                  {menuItem.title}
              </MenuItem>
            );
          }
        })}
        </Menu>
      </div>
    );
  }
}

SectionMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
};

SectionMenu.defaultProps = {
  menuItems: []
};

const mapStateToProps = state => ({
  help: state.help,
});


export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(SectionMenu);



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/SectionMenu.jsx